// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kHwT","colBig":"styles_colBig__25euM","colSmall":"styles_colSmall__2l5KG","shopifyNameWrapper":"styles_shopifyNameWrapper__e2G2K"};